import { CurrentReferencing } from '../../services/utils/types';
import { GlobalState } from '../reducers';

export const getCurrentReferencing = (state: GlobalState): CurrentReferencing | null =>
    state.resources.currentReferencing;
